/* Collection */
class EventLogCollection extends App.Collections.BaseCollection {
    url = 'EventLog';
    model = App.Models.EventLog;

    appendSortParam = (sortValue) => {
        let sortParam = '';
        if (sortValue) {
            sortParam = '?sort=' + sortValue;
        }
        return sortParam;
    }

    allDay = (sortValue) => {
        const initDay = new Date().setHours(0, 0, 0, 0);
        const beginDay = Monet.Format.DateTime.formatToISOString(initDay);
        this.url = 'EventLog/grouped/' + beginDay + '/' + beginDay + '/checked/false' + this.appendSortParam(sortValue);
    }

    clearEventsCheckedTrue = () => {
        const now = Monet.Format.DateTime.getTodayISOString({ locale: 'en' });
        this.url = 'EventLog/since/' + now + '/checked/true';
    }

    sinceMinuteAgo = (lastDate, sortValue) => {
        const initDay = new Date().setHours(0, 0, 0, 0);
        const beginDay = Monet.Format.DateTime.formatToISOString(initDay);

        this.url = 'EventLog/grouped/' + lastDate + '/' + beginDay + '/checked/false' + this.appendSortParam(sortValue);
    }

    getByEventType = (eventTypeId, timeValuedTrue, sortValue) => {
        this.url = 'EventLog/byEventType/' + eventTypeId + '/' + timeValuedTrue + '/checked/false' + this.appendSortParam(sortValue);
    }
}

App.Collections.EventLogs = EventLogCollection;
